var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM14.2 16.25C13.07 16.25 12.15 15.33 12.15 14.2C12.15 13.54 12.47 12.96 12.96 12.58C12.54 11.48 11.49 10.72 10.31 10.76L8.25 10.77H8.24C7.63 10.77 7.05 10.59 6.56 10.28V12.3C7.32 12.6 7.86 13.34 7.86 14.2C7.86 15.33 6.94 16.25 5.81 16.25C4.68 16.25 3.76 15.33 3.76 14.2C3.76 13.33 4.3 12.6 5.06 12.3V7.95C4.3 7.6 3.76 6.84 3.76 5.95C3.76 4.74 4.75 3.75 5.96 3.75C7.17 3.75 8.16 4.74 8.16 5.95C8.16 6.93 7.51 7.75 6.62 8.04C6.82 8.77 7.48 9.28 8.24 9.28C8.24 9.28 8.24 9.28 8.25 9.28L10.31 9.27C10.32 9.27 10.32 9.27 10.33 9.27C12.17 9.27 13.82 10.44 14.42 12.18C15.45 12.29 16.26 13.15 16.26 14.21C16.25 15.33 15.33 16.25 14.2 16.25Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutDiagram);
export default __webpack_public_path__ + "static/media/layout_diagram.80187cc539818c5a9e7bd4750f0d8cda.svg";
export { ForwardRef as ReactComponent };